function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.689.935C4.426.935.144 5.217.144 10.481c0 5.263 4.282 9.545 9.545 9.545s9.546-4.282 9.546-9.545c0-5.264-4.283-9.546-9.546-9.546zm6.033 7.768c-.017.032-.041.061-.062.091-.068.1-.149.194-.25.273l-6.847 5.335-.025.014c-.096.072-.201.126-.311.168-.021.008-.041.011-.063.018-.113.034-.228.055-.344.057h-.003c-.083 0-.166-.012-.249-.028l-.073-.022c-.057-.015-.112-.033-.165-.057-.03-.013-.058-.029-.087-.044-.044-.024-.092-.051-.133-.082-.029-.021-.057-.044-.085-.068-.015-.014-.037-.025-.052-.041l-2.709-2.649c-.331-.325-.426-.792-.304-1.208.011-.032.012-.067.023-.098.058-.146.145-.284.261-.403.468-.475 1.234-.486 1.709-.018l1.956 1.91 6.013-4.688c.528-.411 1.287-.316 1.696.211.311.393.334.917.104 1.329z"
});

var SvgSuccessIcon = function SvgSuccessIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccessIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success_icon.3c2413f9.svg";
export { ForwardRef as ReactComponent };